import { render, staticRenderFns } from "./liveTitle.vue?vue&type=template&id=1888dc00&scoped=true&"
import script from "./liveTitle.vue?vue&type=script&lang=js&"
export * from "./liveTitle.vue?vue&type=script&lang=js&"
import style0 from "./liveTitle.vue?vue&type=style&index=0&id=1888dc00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1888dc00",
  null
  
)

export default component.exports